import ErrorCircleRegular from 'mini-fluent-svg-icons/lib/icons/ErrorCircleRegular';
import showToast from './showToast';
import type ToastItem from '../store/schema/ToastItem';

/**
 * This util shows the error toast taking the toast properties as an input object
 * @param item
 */
export default function showErrorToast(item: ToastItem): void {
    if (!item.icon) {
        item.icon = ErrorCircleRegular;
    }
    showToast(item);
}
